import React from 'react'
import { Table } from 'react-bootstrap'
import ScreenshotPlaceholder from '../../../components/ScreenshotPlaceholder'
import { Tip, Warn, Code, ArticleLink, Ext, TemplateBtn } from '../_helpers'

export const SECTION_ARTICLES = [
  {
    id: 'tb-upload-errors',
    category: 'troubleshooting',
    title: 'Γιατί απέτυχε η μεταφόρτωσή μου; — επεξήγηση μηνυμάτων σφάλματος',
    summary: 'Κάθε κόκκινο σφάλμα και κίτρινη προειδοποίηση, με την αιτία και τη λύση.',
    body: (
      <>
        <p>
          Όταν μια μεταφόρτωση απορρίπτεται, εμφανίζεται ένα <strong>κόκκινο</strong> banner και μια
          λίστα προβλημάτων. Τα <strong>κίτρινα</strong> μηνύματα είναι μόνο προειδοποιήσεις — το
          αρχείο εξακολουθεί να γίνεται αποδεκτό. Βρείτε το μήνυμά σας παρακάτω.
        </p>

        <h5 className="mt-3">Κόκκινα σφάλματα (το αρχείο απορρίπτεται)</h5>
        <Table bordered size="sm" responsive className="small">
          <thead style={{ background: 'var(--color-neutral-100)' }}>
            <tr><th>Μήνυμα</th><th>Τι σημαίνει &amp; πώς να το διορθώσετε</th></tr>
          </thead>
          <tbody>
            <tr>
              <td><Code>Missing required column: "..."</Code></td>
              <td>Η γραμμή επικεφαλίδων δεν περιέχει μια στήλη που χρειάζεται το αρχείο — συνήθως
                διαφορά ορθογραφίας ή πεζών/κεφαλαίων. Οι επικεφαλίδες πρέπει να ταιριάζουν ακριβώς,
                π.χ. <Code>consumption_kwh</Code>, όλα πεζά. Διορθώστε την πρώτη γραμμή και
                μεταφορτώστε ξανά.</td>
            </tr>
            <tr>
              <td><Code>Value must be a number, got: "..."</Code></td>
              <td>Ένα κελί που πρέπει να περιέχει αριθμό περιέχει κάτι άλλο — σχεδόν πάντα
                <strong> δεκαδικό κόμμα</strong> (<Code>3,5</Code>)· πρέπει να είναι τελεία
                (<Code>3.5</Code>). Για μαζική μετατροπή αρχείου, δείτε{' '}
                <ArticleLink to="data-fix-commas">Διόρθωση αρχείου με κόμματα ως δεκαδικά</ArticleLink>.
                Αφαιρέστε επίσης μονάδες, κενά ή άλλο κείμενο από κελιά αριθμών.</td>
            </tr>
            <tr>
              <td><Code>Value must be non-negative, got: ...</Code></td>
              <td>Μια τιμή κατανάλωσης, παραγωγής ή τιμής είναι αρνητική. Αυτές δεν μπορούν να είναι
                κάτω από το μηδέν — ένας αρνητικός αριθμός συνήθως σημαίνει ότι δύο στήλες
                αντιμετατέθηκαν.</td>
            </tr>
            <tr>
              <td><Code>Invalid timestamp format: "..."</Code></td>
              <td>Ένα κελί ημερομηνίας/ώρας δεν μπόρεσε να αναγνωστεί. Χρησιμοποιήστε{' '}
                <Code>2025-01-01T14:00:00Z</Code>. Δείτε{' '}
                <ArticleLink to="data-csv-basics">Δημιουργία αρχείων CSV σωστά</ArticleLink> για τις
                αποδεκτές μορφές ημερομηνίας και έναν τύπο που διορθώνει μια ολόκληρη στήλη
                ταυτόχρονα.</td>
            </tr>
            <tr>
              <td><Code>CSV file contains no data rows</Code></td>
              <td>Το αρχείο έχει μόνο μια γραμμή επικεφαλίδων ή είναι κενό. Προσθέστε τις ωριαίες
                γραμμές δεδομένων σας.</td>
            </tr>
            <tr>
              <td><Code>period_start must be before period_end</Code></td>
              <td>(Αρχεία λογαριασμών ενέργειας) Η ημερομηνία έναρξης ενός λογαριασμού είναι ίδια ή
                μεταγενέστερη από την ημερομηνία λήξης. Διορθώστε τις ημερομηνίες.</td>
            </tr>
          </tbody>
        </Table>

        <h5 className="mt-4">Κίτρινες προειδοποιήσεις (το αρχείο γίνεται αποδεκτό)</h5>
        <Table bordered size="sm" responsive className="small">
          <thead style={{ background: 'var(--color-neutral-100)' }}>
            <tr><th>Μήνυμα</th><th>Τι σημαίνει</th></tr>
          </thead>
          <tbody>
            <tr><td><Code>Extra columns found and will be ignored</Code></td><td>Το αρχείο σας έχει στήλες που η πλατφόρμα δεν χρησιμοποιεί. Αβλαβές — απλώς παραλείπονται.</td></tr>
            <tr><td><Code>... gap(s) detected in the time series</Code></td><td>Ορισμένες ώρες λείπουν μεταξύ της πρώτης και της τελευταίας γραμμής σας. Προσθέστε τις ώρες που λείπουν για καλύτερη ακρίβεια.</td></tr>
            <tr><td><Code>timestamp(s) are not in chronological order</Code></td><td>Οι γραμμές δεν είναι ταξινομημένες χρονικά. Ταξινομήστε το αρχείο κατά τη στήλη χρονικής σήμανσης.</td></tr>
            <tr><td><Code>has ... missing value(s)</Code></td><td>Ορισμένα κελιά σε μια αριθμητική στήλη είναι κενά. Συμπληρώστε τα (χρησιμοποιήστε <Code>0</Code> όπου χρειάζεται).</td></tr>
            <tr><td><Code>... potential outliers</Code></td><td>Μερικές τιμές είναι ασυνήθιστα υψηλές ή χαμηλές. Ελέγξτε τες σε περίπτωση τυπογραφικού λάθους, διαφορετικά αγνοήστε τες.</td></tr>
            <tr><td><Code>contains all zero values</Code></td><td>Μια ολόκληρη στήλη είναι μηδέν. Φυσιολογικό για νυχτερινή ηλιακή ενέργεια· διαφορετικά ελέγξτε αν εξαγάγατε τα σωστά δεδομένα.</td></tr>
          </tbody>
        </Table>
        <Tip>
          Τα περισσότερα κόκκινα σφάλματα προέρχονται από το δεκαδικό κόμμα ή από λανθασμένες
          επικεφαλίδες. Η εκκίνηση από ένα κατεβασμένο πρότυπο αποφεύγει και τα δύο — δείτε{' '}
          <em>«Δημιουργία αρχείων CSV σωστά»</em>.
        </Tip>
      </>
    ),
  },

  // =========================================================================
  {
    id: 'tb-forecast-flat',
    category: 'troubleshooting',
    title: 'Η πρόβλεψή μου φαίνεται επίπεδη ή λάθος',
    summary: 'Όταν η προβλεπόμενη γραμμή είναι επίπεδη, αντίγραφο της χθεσινής ή εντελώς εκτός — τι να ελέγξετε.',
    body: (
      <>
        <p>Αν μια πρόβλεψη φαίνεται αναποτελεσματική, σχεδόν πάντα ένας από αυτούς τους λόγους
          ευθύνεται.</p>

        <Table bordered size="sm" responsive className="small">
          <thead style={{ background: 'var(--color-neutral-100)' }}>
            <tr><th>Τι βλέπετε</th><th>Πιο πιθανή αιτία</th><th>Τι να κάνετε</th></tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Επίπεδη γραμμή</strong> — η πρόβλεψη είναι μια ενιαία τιμή σε όλο τον ορίζοντα.</td>
              <td>Πολύ λίγο ιστορικό εισόδου, ή η είσοδος είναι ως επί το πλείστον μηδενικά / μια επαναλαμβανόμενη τιμή.</td>
              <td>Μεταφορτώστε περισσότερο ιστορικό (τουλάχιστον ένα μήνα, ιδανικά ένα χρόνο). Βεβαιωθείτε ότι το αρχείο δεν περιέχει μια μόνο επαναλαμβανόμενη τιμή.</td>
            </tr>
            <tr>
              <td><strong>«Αντίγραφο της χθεσινής»</strong> — η πρόβλεψη μοιάζει με τις τελευταίες 24 ώρες, μετατοπισμένη.</td>
              <td>Το μοντέλο έχει επιστρέψει σε αφελή βάση επειδή τα δεδομένα είναι πολύ σύντομα για την εκπαίδευση πραγματικού μοντέλου.</td>
              <td>Προσθέστε περισσότερο ιστορικό. Προσθέστε αρχείο καιρού για ηλιακές προβλέψεις (δείτε <ArticleLink to="data-weather">Αρχεία καιρού</ArticleLink>).</td>
            </tr>
            <tr>
              <td><strong>Αιχμές / αρνητικές τιμές</strong> στην πρόβλεψη.</td>
              <td>Ακραίες τιμές στο ιστορικό (π.χ. δυσλειτουργία μετρητή) παραμορφώνουν το μοντέλο.</td>
              <td>Ανοίξτε το αρχείο ιστορικού, εντοπίστε την ύποπτη γραμμή, διορθώστε ή αφαιρέστε την, μεταφορτώστε ξανά και επαναλάβετε την εκτέλεση.</td>
            </tr>
            <tr>
              <td><strong>Πολύ πλατύ εύρος εμπιστοσύνης</strong>.</td>
              <td>Το μοντέλο γνωρίζει ότι είναι αβέβαιο — συνήθως λόγω σύντομου ιστορικού ή ασυνήθιστα πρόσφατων δεδομένων.</td>
              <td>Προσθέστε περισσότερα δεδομένα· αναμένετε να στενέψει το εύρος στην επόμενη εκτέλεση.</td>
            </tr>
            <tr>
              <td><strong>Ειδοποίηση «Δεδομένα δείγματος» στη σελίδα</strong>.</td>
              <td>Η υπηρεσία πρόβλεψης ήταν μη διαθέσιμη ή τα δεδομένα ήταν ανεπαρκή — εμφανίζονται ενδεικτικά αποτελέσματα.</td>
              <td>Ελέγξτε τη σελίδα μεταφόρτωσης για τυχόν αρχεία που λείπουν· δοκιμάστε ξανά σε λίγα λεπτά.</td>
            </tr>
            <tr>
              <td><strong>Η ηλιακή πρόβλεψη είναι κατά προσέγγιση σωστή αλλά το μέγεθος είναι λάθος</strong>.</td>
              <td>Η εγκατεστημένη ισχύς Φ/Β / ο προσανατολισμός των πανέλων μπορεί να είναι ρυθμισμένος λανθασμένα στο στοιχείο, ή το αρχείο παραγωγής χρησιμοποιεί kWh όπου αναμένεται kW (ή το αντίστροφο).</td>
              <td>Επαληθεύστε την εγκατεστημένη ισχύ του στοιχείου (kWp). Επαληθεύστε ότι η μονάδα του αρχείου παραγωγής ταιριάζει με αυτό που αναμένει η πλατφόρμα στη σελίδα μεταφόρτωσης.</td>
            </tr>
          </tbody>
        </Table>

        <Tip>
          Ένας χρήσιμος έλεγχος: αν προβλέψετε μια <em>περασμένη</em> μέρα ενός κτιρίου και η
          πρόβλεψη δεν μοιάζει καθόλου με αυτό που συνέβη, το μοντέλο υποεξυπηρετείται. Η
          προσθήκη ιστορικού είναι σχεδόν πάντα πιο αποτελεσματική από την τροποποίηση ρυθμίσεων.
        </Tip>
      </>
    ),
  },

  // =========================================================================
  {
    id: 'tb-optimisation-infeasible',
    category: 'troubleshooting',
    title: 'Η βελτιστοποίηση εμφανίζει «infeasible»',
    summary: 'Όταν η εκτέλεση βελτιστοποίησης αποτυγχάνει να βρει οποιοδήποτε έγκυρο πρόγραμμα — συνήθεις αιτίες και λύσεις.',
    body: (
      <>
        <p>
          Το «infeasible» σημαίνει ότι ο βελτιστοποιητής δεν μπόρεσε να βρει <em>κανένα</em>{' '}
          πρόγραμμα που να ικανοποιεί κάθε περιορισμό ταυτόχρονα. Συνήθως ένας περιορισμός είναι
          πολύ αυστηρός.
        </p>

        <h5 className="mt-3">Τι να ελέγξετε, με σειρά</h5>
        <ol>
          <li>
            <strong>Χωρητικότητα μπαταρίας έναντι ζήτησης.</strong> Αν αναγκάσατε την μπαταρία να
            καλύψει την αιχμή του βραδιού αλλά η χωρητικότητά της είναι πολύ μικρή, ο βελτιστοποιητής
            δεν έχει έγκυρο σχέδιο. Αυξήστε τη χωρητικότητα της μπαταρίας ή χαλαρώστε τον
            περιορισμό.
          </li>
          <li>
            <strong>Παράθυρο σύνδεσης EV έναντι απαιτούμενης ενέργειας.</strong> Αν ένα EV χρειάζεται
            40 kWh αλλά είναι συνδεδεμένο μόνο για 2 ώρες στα 7 kW (=14 kWh μέγιστο), δεν μπορεί να
            φορτιστεί πλήρως. Διευρύνετε το παράθυρο ή μειώστε τον απαιτούμενο SOC.
          </li>
          <li>
            <strong>Στόχος αυτάρκειας έναντι παραγωγής.</strong> Ένας στόχος «100% αυτάρκεια» με
            λίγα Φ/Β και χωρίς επιτρεπόμενη εισαγωγή από δίκτυο είναι αδύνατος. Χαμηλώστε τον
            στόχο ή επιτρέψτε κάποια εισαγωγή.
          </li>
          <li>
            <strong>Όρια ελάχιστου/μέγιστου SOC.</strong> Αν το ελάχιστο SOC είναι υψηλότερο από το
            μέγιστο SOC (ή και τα δύο καρφωμένα στο ίδιο επίπεδο), δεν υπάρχει χώρος λειτουργίας.
            Ελέγξτε και τα δύο όρια.
          </li>
          <li>
            <strong>Αρνητικές τιμές τιμολογίου.</strong> Ορισμένες εξαγωγές εμφανίζουν αρνητικές
            χονδρικές τιμές σε πραγματικές αγορές. Αν ορίσατε κανόνα «εξαγωγή ≥ 0», αυτές οι ώρες
            γίνονται infeasible. Αφαιρέστε τον κανόνα ή φιλτράρετε εκ των προτέρων το αρχείο
            τιμολογίου.
          </li>
          <li>
            <strong>Κενά δεδομένα εντός του ορίζοντα.</strong> Ένα κενό στο αρχείο φορτίου ή
            τιμολογίου εντός του ορίζοντα βελτιστοποίησης μπορεί να διακόψει τον επιλύτη.
            Μεταφορτώστε ξανά το αρχείο με το κενό συμπληρωμένο (χρησιμοποιήστε την τιμή της
            προηγούμενης ώρας ή 0).
          </li>
        </ol>

        <h5 className="mt-3">Πώς να διαγνώσετε γρήγορα</h5>
        <p>
          Εκτελέστε ξανά με τον στόχο <strong>«Ελαχιστοποίηση κόστους»</strong> και <em>χωρίς</em>{' '}
          σκληρό στόχο αυτάρκειας / αυτοκατανάλωσης. Αν αυτό πετύχει, ο δεσμευτικός περιορισμός
          ήταν ο στόχος σας — χαλαρώστε τον. Αν εξακολουθεί να αποτυγχάνει, ο δεσμευτικός
          περιορισμός είναι η χωρητικότητα στοιχείων ή κενό δεδομένων.
        </p>
        <Tip>
          Ο υποδιπλασιασμός του ορίζοντα (24 ώρ → 12 ώρ) μερικές φορές πετυχαίνει όταν οι 24 ώρες
          αποτυγχάνουν. Αυτό δείχνει σε συγκεκριμένο χρονικό τμήμα όπου βρίσκεται το πρόβλημα —
          επιθεωρήστε αυτό το τμήμα στα δεδομένα σας.
        </Tip>
      </>
    ),
  },

  // =========================================================================
  {
    id: 'tb-kpi-sanity-check',
    category: 'troubleshooting',
    title: 'Τα KPI μου φαίνονται πολύ καλά — ή πολύ κακά',
    summary: 'Όταν η αυτάρκεια είναι 99%, το NPV τεράστιο, ή η περίοδος αποπληρωμής απίθανα σύντομη — τι να ελέγξετε.',
    body: (
      <>
        <p>
          Ένα KPI που φαίνεται «πολύ καλό για να είναι αληθινό» σχεδόν πάντα προέρχεται από ένα
          μικρό σύνολο λαθών δεδομένων. Εκτελέστε αυτούς τους ελέγχους πριν κοινοποιήσετε το
          αποτέλεσμα.
        </p>

        <h5 className="mt-3">Αν η αυτάρκεια ή η αυτοκατανάλωση είναι απίθανα υψηλή</h5>
        <ul>
          <li><strong>Το αρχείο κατανάλωσης έχει πολύ μικρή κλίμακα.</strong> Τιμές kW εισήχθησαν σε στήλη kWh (ή το αντίστροφο) κάνουν την κοινότητα να φαίνεται μικροσκοπική σε σχέση με τα Φ/Β της. Επανελέγξτε τη μονάδα στη σελίδα μεταφόρτωσης.</li>
          <li><strong>Μεταφορτώθηκε μόνο μέρος του έτους.</strong> Αν μεταφορτώσατε μόνο τους καλοκαιρινούς μήνες, φυσικά η ηλιακή ενέργεια καλύπτει το μεγαλύτερο μέρος της ζήτησης. Μεταφορτώστε ένα πλήρες έτος για αντιπροσωπευτικό αποτέλεσμα.</li>
          <li><strong>Κτίρια που λείπουν.</strong> Μόνο ένα από τα τρία κτίρια βρίσκεται στην πλατφόρμα, οπότε η κοινότητα φαίνεται μικρότερη και περισσότερο καλυμμένη από την ηλιακή ενέργεια από ό,τι στην πραγματικότητα.</li>
        </ul>

        <h5 className="mt-3">Αν το NPV ή οι ετήσιες εξοικονομήσεις είναι απίθανα μεγάλες</h5>
        <ul>
          <li><strong>Τιμολόγιο σε λανθασμένες μονάδες.</strong> €/MWh που αντιμετωπίζεται ως €/kWh φουσκώνει τις εξοικονομήσεις κατά 1000×. Ανοίξτε το αρχείο τιμολογίου — μια τιμή <Code>120</Code> πρέπει να είναι <Code>0.12</Code> αν αντιπροσωπεύει €/kWh.</li>
          <li><strong>Πολύ μεγάλη διάρκεια ζωής.</strong> Ένας ορίζοντας 30 ετών για μπαταρία 15 ετών υπερεκτιμά τις εξοικονομήσεις. Αντιστοιχίστε τη διάρκεια ζωής με το στοιχείο.</li>
          <li><strong>Προεξοφλητικό επιτόκιο ορισμένο στο 0%.</strong> Χωρίς προεξόφληση οι μελλοντικές εξοικονομήσεις μετρώνται πλήρως — συνήθως μη ρεαλιστικό. Χρησιμοποιήστε 3–6% εκτός αν το τμήμα χρηματοοικονομικών σας υποδείξει διαφορετικά.</li>
          <li><strong>Πολύ επιθετική υπόθεση πληθωρισμού.</strong> Αν υποθέσατε ότι οι τιμές ηλεκτρισμού αυξάνονται 8% ετησίως για πάντα, οι εξοικονομήσεις εκρήγνυνται. Χρησιμοποιήστε συνετό ποσοστό (1–4%).</li>
        </ul>

        <h5 className="mt-3">Αν τα αποτελέσματα φαίνονται απίθανα κακά</h5>
        <ul>
          <li><strong>Το αρχείο τιμολογίου λείπει ή είναι πλήρως μηδενικό.</strong> Χωρίς τιμή = χωρίς εξοικονομήσεις για μέτρηση. Μεταφορτώστε το τιμολόγιο και εκτελέστε ξανά.</li>
          <li><strong>Η εγκατεστημένη ισχύς Φ/Β παρέμεινε στα 0 kWp.</strong> Ελέγξτε το στοιχείο στη σελίδα πόρων της κοινότητας.</li>
          <li><strong>Λανθασμένος βαθμός απόδοσης μπαταρίας.</strong> Μια προεπιλογή 50% θα έκανε την μπαταρία να «χάνει» τη μισή από κάθε kWh — ελέγξτε την απόδοση πλήρους κύκλου (round-trip) του στοιχείου.</li>
          <li><strong>Αρχείο παραγωγής στη λάθος στήλη.</strong> Αν η κατανάλωση και η παραγωγή αντιμετατέθηκαν, ο βελτιστοποιητής βλέπει το κτίριο να μην παράγει τίποτα.</li>
        </ul>

        <Tip>
          Ένας χρήσιμος έλεγχος λογικής: διαιρέστε τις ετήσιες εξοικονομήσεις με τον ετήσιο
          λογαριασμό ηλεκτρισμού της κοινότητας. Αν το αποτέλεσμα είναι πάνω από 50–70%, κάτι
          πιθανότατα υπερεκτιμάται. Τα πραγματικά κοινοτικά ενεργειακά έργα συνήθως μειώνουν τους
          λογαριασμούς κατά 10–40%.
        </Tip>
      </>
    ),
  },

  // =========================================================================
  {
    id: 'tb-faq',
    category: 'troubleshooting',
    title: 'Συχνές ερωτήσεις',
    summary: 'Σύντομες απαντήσεις σε συνήθεις ερωτήσεις.',
    body: (
      <>
        <h5>Χρειάζομαι δεδομένα ολόκληρου του έτους;</h5>
        <p>Ένα πλήρες έτος (8.760 ωριαίες γραμμές) δίνει τα καλύτερα αποτελέσματα, αλλά τα εργαλεία
          λειτουργούν και με λιγότερο. Τουλάχιστον μία μέρα (24 γραμμές) απαιτείται για αρχεία
          βασισμένα στον χρόνο.</p>

        <h5 className="mt-3">Το αρχείο μου χρησιμοποιεί ερωτηματικό ( ; ) μεταξύ τιμών — είναι πρόβλημα;</h5>
        <p>Όχι. Η πλατφόρμα εντοπίζει αυτόματα κόμματα, ερωτηματικά και tabs. Ο δεκαδικός
          διαχωριστής μέσα στους αριθμούς εξακολουθεί να πρέπει να είναι τελεία.</p>

        <h5 className="mt-3">Μπορώ να μεταφορτώσω ξανά τον ίδιο τύπο αρχείου;</h5>
        <p>Ναι — η εκ νέου μεταφόρτωση αντικαθιστά το προηγούμενο αρχείο για αυτόν τον τύπο (για
          τιμολόγια Day-Ahead, το αρχείο κάθε μέρας φυλάσσεται χωριστά ανά ημερομηνία).</p>

        <h5 className="mt-3">Τα αποτελέσματα μοιάζουν με δεδομένα δείγματος — γιατί;</h5>
        <p>Αν μια υπηρεσία υπολογισμού είναι προσωρινά μη διαθέσιμη, ή τα απαιτούμενα δεδομένα δεν
          έχουν ακόμα μεταφορτωθεί, η πλατφόρμα εμφανίζει σαφώς επισημασμένα ενδεικτικά
          αποτελέσματα ώστε να μπορείτε να εξερευνήσετε. Μεταφορτώστε πραγματικά δεδομένα και
          εκτελέστε ξανά το εργαλείο για πραγματικά αποτελέσματα.</p>

        <h5 className="mt-3">Γιατί ένα κουμπί είναι γκριζαρισμένο;</h5>
        <p>Ορισμένοι λογαριασμοί είναι μόνο για ανάγνωση (ρόλος θεατή), και ορισμένες ενέργειες
          απαιτούν να έχουν μεταφορτωθεί δεδομένα πρώτα. Τοποθετήστε τον κέρσορα πάνω από το
          κουμπί ή ελέγξτε τις υποδείξεις της σελίδας για να δείτε τι απαιτείται.</p>
      </>
    ),
  },
]
